import { IProductCategoryDropDown } from 'src/api/product-category'

export const getProductCategoryDisplayName = (category: IProductCategoryDropDown): string => {
  const name = category.name?.trim()
  if (name) return name
  return String(category.id)
}

export const reorderFilterCategoryIds = <T,>(items: T[], fromIndex: number, toIndex: number): T[] => {
  if (fromIndex === toIndex) return items
  const next = [...items]
  const [moved] = next.splice(fromIndex, 1)
  next.splice(toIndex, 0, moved)
  return next
}
